import React from 'react';

import requireAuth from '~components/hocs/requireAuth';
import { SearchPerformanceConnect, hasSearchPerformanceAccess } from '~features/SearchPerformance';
import AdminTemplate from '../layout/AdminTemplate';

const META_TAGS = {
  title: 'Connect Google Search Console - Prerender.io',
};

function SearchPerformanceConnectPage() {
  return (
    <AdminTemplate metaTags={META_TAGS}>
      <SearchPerformanceConnect />
    </AdminTemplate>
  );
}

// Same gate as the dashboard route — the connect flow reaches the same
// feature-flagged endpoints, which rest-api guards server-side too.
export default requireAuth(SearchPerformanceConnectPage, hasSearchPerformanceAccess);
